module.exports = __webpack_public_path__ + "img/4ed434a6681e69c145e09c94816e86b7.svg";